module.exports = __webpack_public_path__ + "static/media/nuts.e4a50d50.svg";